import React, { useState } from 'react';
import Modal from 'react-modal';
import { Grid, makeStyles } from '@material-ui/core';
import CustomPopupTopBar from '../../shared/CustomPopupTopBar';
import CustomPopupText from '../../shared/CustomPopupText';
import CustomTextField from '../../shared/CustomTextField';
import CustomButton from '../../shared/CustomButton';
import { MultipleErrorToast } from '../../utils/Utils';
import useAdminUsers from '../hooks/useAdminUsers';
import { INITIAL_CREATE_FORM, EMAIL_REGEX } from '../constants';

const customStyles = {
  content: {
    height: 'auto',
    maxHeight: '90vh',
    width: '460px',
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    padding: '0px',
    overflow: 'hidden',
  },
};

const useStyles = makeStyles(() => ({
  body: { padding: '24px' },
  field: { marginBottom: '12px' },
  footer: { marginTop: '10px', gap: '10px' },
}));

const AdminUserAddNewPopup = ({ close }) => {
  const classes = useStyles();
  const { createAdmin } = useAdminUsers();
  const [form, setForm] = useState(INITIAL_CREATE_FORM);

  const handleChange = ({ target: { name, value } }) => setForm((prev) => ({ ...prev, [name]: value }));

  const validate = () => {
    const errors = [];
    if (!form.firstName.trim()) errors.push('First name is required.');
    if (!form.lastName.trim()) errors.push('Last name is required.');
    if (!EMAIL_REGEX.test(form.email.trim())) errors.push('A valid email is required.');
    if (errors.length) {
      MultipleErrorToast(errors);
      return false;
    }
    return true;
  };

  const handleSave = async () => {
    if (!validate()) return;
    const ok = await createAdmin({
      firstName: form.firstName.trim(),
      lastName: form.lastName.trim(),
      email: form.email.trim(),
    });
    if (ok) close();
  };

  return (
    <Modal isOpen onRequestClose={close} shouldCloseOnEsc style={customStyles}>
      <CustomPopupTopBar add title="Admin User" close={close} />
      <div className={classes.body}>
        <div className={classes.field}>
          <CustomPopupText text="First Name" required />
          <CustomTextField name="firstName" value={form.firstName} handleChange={handleChange} />
        </div>
        <div className={classes.field}>
          <CustomPopupText text="Last Name" required />
          <CustomTextField name="lastName" value={form.lastName} handleChange={handleChange} />
        </div>
        <div className={classes.field}>
          <CustomPopupText text="Email" required />
          <CustomTextField name="email" value={form.email} handleChange={handleChange} />
        </div>
        <Grid container justifyContent="flex-start" className={classes.footer}>
          <CustomButton label="Create" variant="contained" size="large" type="primary" onClick={handleSave} />
          <CustomButton label="Cancel" variant="contained" size="large" type="secondary" onClick={close} />
        </Grid>
      </div>
    </Modal>
  );
};

export default AdminUserAddNewPopup;
